import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      minHeight: rem(40),
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px 0px',
      borderTop: '1px solid #e4e8ec',
      backgroundColor: theme.colors.neutral[0],
      cursor: 'pointer',
      textDecoration: 'none',
      '&[data-align-left="true"]': {
        justifyContent: 'start',
      },
      //   '.sticky-sponsored-info-icon': {
      //     display: 'inline',
      //     verticalAlign: 'middle',
      //   },
      [theme.fn.largerThan('sm')]: {
        minHeight: '44px',
      },
      '&[data-show-popup="true"]': {
        '.sticky-sponsored-info-icon': {
          position: 'relative',
          '&:before': {
            position: 'absolute',
            zIndex: 9,
            top: '100%',
            left: '9px',
            borderRight: '6px transparent solid',
            borderBottom: '8px white solid',
            borderLeft: '6px transparent solid',
            content: '" "',
            transform: 'translateX(calc(-50% + 3px))',
          },
        },
      },
    },
    logo: {
      height: rem(32),
      [theme.fn.largerThan('sm')]: {
        height: rem(36),
      },
    },
    logoWrapper: {
      display: 'inline-block',
      overflowX: 'auto',
      gap: '24px',
      marginLeft: '24px',
      '-ms-overflow-style': 'none' /* for Internet Explorer, Edge */,
      'scrollbar-width': 'none' /* for Firefox */,
      '&::-webkit-scrollbar': {
        display: 'none' /* for Chrome, Safari, and Opera */,
      },
      whiteSpace: 'nowrap',
      flexShrink: 0,
      [theme.fn.smallerThan('sm')]: {
        display: 'inline',
        marginLeft: '8px',
      },
    },
    scrollBtn: {
      display: 'flex',
      marginLeft: rem(24),
      gap: rem(32),
    },
    img: {
      width: rem(32),
      height: rem(32),
    },
    textWrapper: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    container: {
      position: 'relative',
      padding: '0 16px',
    },
  }
})
